




























































































































































































































































































































import { Meta } from "@/store/meta"
import { Vue, Component } from "vue-property-decorator"
import { Server, EditServiceForm } from '@/store/server'
import { getModule } from "vuex-module-decorators"
import EditModal, { EditContents } from '@/components/EditModal.vue'
import EditBoccoChannelVUI from '@/modal/EditBoccoChannelVUI.vue'
import EditWebhook from '@/modal/EditBoccoChannelWebhook.vue'
import VueQrcode from 'qrcode.vue';
import Tips from "./Tips.vue"


@Component({
  components: {
      'edit-modal': EditModal,
      'edit-vui-modal': EditBoccoChannelVUI,
      'edit-webhook-modal': EditWebhook,
      VueQrcode, Tips
  }
})

export default class ConfigService extends Vue {
  loaded = false
  isServiceReady = false
  serviceIndex = 0

  // paginate
  rangeBefore= 2
  rangeAfter= 2
  order= 'is-centered'
  size= 'is-small'
  isSimple= false
  prevIcon= 'chevron-left'
  nextIcon= 'chevron-right'

  // modal
  isEditModalActive = false
  isEditUserModalActive = false
  isVoiceCommandModalActive = false
  isWebhookModalActive = false

  editTitle = 'サービス編集'
  editContents = {
    name: '',
    description: '',
    icon: '',
    url: '',
    published: false
  }

  editUserContents = {
    name: ''
  }

  qrSource = ""

  // 購読中の部屋セクション (Issue #267) — サービス broadcasterUuid をキーに X-Channel-User 付きで
  // getRooms を叩く。ページネーションは backend-pagination で自前ハンドラを介する。
  roomsLoading = false
  copiedUuid = ""

  get isLoading() {
    return !this.loaded
  }

  get uuid() {
    return this.$route.params.id
  }

  get currentService() {
    return this.server.boccoChannel!.services.filter(x => x.uuid == this.uuid)[0]
  }

  get currentUser() {
    return this.server.currentBoccoChannelServiceUser
  }

  async mounted() {
    if (this.server.boccoChannel == null) {
      await this.server.getBoccoChannel()
    }

    await this.server.getBoccoChannelDestributionUser(this.currentService.uuid)

    this.loaded = true
    this.isServiceReady = true

    // 購読中の部屋一覧を先行取得。QR と並列でよいが await はしない (レイテンシ影響を最小化)。
    this.loadRoomsSection()

    this.qrSource = JSON.stringify({
      type: "bocco_channel",
      "bocco_channel": await this.server.getBoccoChannelQRInformation(this.currentService.uuid)
    })
  }

  get isRoomsLoading() {
    return this.roomsLoading
  }

  get hasRooms() {
    return this.server.roomsData.rooms.length > 0
  }

  get roomEntries() {
    return this.server.roomsData.rooms
  }

  get roomsTotal() {
    return this.server.roomsData.listing.total
  }

  get roomsPerPage() {
    return this.server.roomsData.listing.limit
  }

  async loadRoomsSection() {
    this.roomsLoading = true
    try {
      await this.server.getRooms({ broadcasterUuid: this.currentService.uuid })
    } catch (e) {
      // 401/429 は interceptor 側で処理済み。他の失敗は空表示に倒す
      return
    } finally {
      this.roomsLoading = false
    }
  }

  async onRoomsPageChanged(page: number) {
    const index = page - 1
    this.roomsLoading = true
    try {
      await this.server.getRooms({
        offset: index * this.roomsPerPage,
        broadcasterUuid: this.currentService.uuid,
      })
    } finally {
      this.roomsLoading = false
    }
  }

  roomDetailLink(uuid: string) {
    this.$router.push({ path: '/rooms/' + uuid, query: { service: this.currentService.uuid } })
  }

  async copyUuid(uuid: string) {
    try {
      await navigator.clipboard.writeText(uuid)
      this.copiedUuid = uuid
      setTimeout(() => {
        if (this.copiedUuid === uuid) this.copiedUuid = ''
      }, 1500)
    } catch (e) {
      console.warn('clipboard copy failed', e)
    }
  }

  get meta() {
    return getModule(Meta)
  }
  get server() {
    return getModule(Server)
  }

  get isViewer() {
    return this.meta.isViewer
  }

  serviceEdit(){
    const tmpContents  = {...this.currentService}

    this.editContents.name =  tmpContents.name
    this.editContents.description =  tmpContents.description
    this.editContents.name =  tmpContents.name
    this.editContents.icon =  tmpContents.icon
    this.editContents.url =  tmpContents.url
    this.editContents.published =  tmpContents.published  

    this.isEditModalActive = true
    return
  }

  userEdit() {
    const tmpContents  = {...this.currentUser}

    this.editUserContents.name = tmpContents.nickname

    this.isEditUserModalActive = true

    return
  }

  voiceCommandEdit() {
    this.isVoiceCommandModalActive = true
  }

  webhookEdit() {
    this.isWebhookModalActive = true
  }

  async editVuiApproved(newValue: string){
    const uuid = this.currentService.uuid

    try {
      await this.server.putBoccoChannelServiceVui({
        uuid: uuid,
        voiceCommand: newValue
      })
      this.$router.push({ path: '/bocco-channel/done' , query :{ editType: 'vui' }});
    } catch (error) {
      this.$buefy.toast.open({
        message: '送信に失敗しました。大変お手数ですが、しばらくお待ちいただいた後に、再度送信をお願いします。',
        type: 'is-danger'
      })
    } finally {
      this.isVoiceCommandModalActive = false
    }
  }
  async editWebhookApproved(newValue: string){
    const uuid = this.currentService.uuid

    try {
      await this.server.putBoccoChannelServiceWebhook({
        uuid: uuid,
        webhook: newValue
      })
      this.currentService["conversation_event_url"] = newValue
    } catch (error) {
      this.$buefy.toast.open({
        message: '送信に失敗しました。大変お手数ですが、しばらくお待ちいただいた後に、再度送信をお願いします。',
        type: 'is-danger'
      })
    } finally {
      this.isWebhookModalActive = false
    }
  }

  // eslint-disable-next-line
  async sendEditData(editValue: EditContents){
    const uuid = this.currentService.uuid

    const form: EditServiceForm = {
      uuid: uuid,
      data: {
        icon: editValue.icon,
        description: editValue.description,
        url: editValue.url,
        published: editValue.published,
        name: editValue.name
      }

    }
    if (this.meta.plan == 'broadcaster') {
      delete editValue["url"]
    }
    
    try {
      await this.server.putBoccoChannelService(form)
      this.$router.push({ path: '/bocco-channel/done' , query :{ editType: 'service' }});
    } catch (error) {
      this.$buefy.toast.open({
        message: '送信に失敗しました。大変お手数ですが、しばらくお待ちいただいた後に、再度送信をお願いします。',
        type: 'is-danger'
      })
    } finally {
      this.isEditModalActive = false
    }
  }

  async sendUserEditRequest(value: any) {
    const uuid = this.currentService.uuid
    
    try {
      await this.server.putBoccoChannelServiceUser({uuid: uuid, data: {
        name: value.name,
        icon: value.icon
      }})

      this.$router.push({ path: '/bocco-channel/done' , query :{ editType: 'user' }});
    } catch (error) {
      console.log(error)
      this.$buefy.toast.open({
        message: '送信に失敗しました。大変お手数ですが、しばらくお待ちいただいた後に、再度送信をお願いします。',
        type: 'is-danger'
      })
    } finally {
      this.isEditUserModalActive = false
    }
  }
}
